import { useEffect, useRef, useState } from 'react';

const WHATSAPP_URL = 'https://wa.me/5535997383261?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20gostaria%20de%20falar%20com%20o%20advogado%20criminalista%20Patrick%20Serafini';

const HERO_IMG_DESKTOP = 'https://storage.readdy-site.link/project_files/7b128e76-fd57-409d-b68f-44ee9d9ff910/fdc8be90-4b1f-41f2-a33a-c0399e38b808_foto-01.png.png?v=956a4558ecfaa028fbe9c4057ca43cf9';

const HERO_IMG_MOBILE = 'https://storage.readdy-site.link/project_files/7b128e76-fd57-409d-b68f-44ee9d9ff910/cd599c30-3322-4fd4-973e-9d68d8bc7aa4_foto-01-b.png.png?v=a63ce19b76b78855f44727db3b4bdcbf';

export default function HeroSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
  }, []);

  return (
    <section
      id="hero"
      ref={sectionRef}
      className="relative min-h-[85vh] md:min-h-screen w-full flex items-end overflow-hidden"
    >
      {/* Background Image Desktop */}
      <div
        className="hidden md:block absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_IMG_DESKTOP})` }}
      />
      {/* Background Image Mobile - posicionada pelo topo para mostrar o rosto */}
      <div
        className="md:hidden absolute inset-0 bg-cover bg-top"
        style={{ backgroundImage: `url(${HERO_IMG_MOBILE})` }}
      />

      {/* Overlay Desktop */}
      <div className="hidden md:block absolute inset-0 bg-gradient-to-r from-navy/85 via-navy/60 to-navy/40" />
      {/* Overlay Mobile - gradiente vertical: topo leve (rosto visivel) para base escura (texto legivel) */}
      <div className="md:hidden absolute inset-0 bg-gradient-to-b from-navy/10 via-navy/30 to-navy/90" />

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10 pb-10 md:pb-24 pt-12 md:pt-40">
        <div className="max-w-4xl mx-auto md:mx-0 text-center md:text-left">
          <h1
            className={`font-cinzel font-bold text-white text-3xl md:text-5xl lg:text-7xl leading-tight tracking-wide transition-all duration-700 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            Defesa Criminal
            <br className="hidden md:block" />
            {' '}
            Especializada no Sul de Minas
          </h1>
          <p
            className={`font-montserrat font-light text-white/90 text-base md:text-lg lg:text-xl mt-4 md:mt-6 max-w-xl mx-auto md:mx-0 leading-relaxed transition-all duration-700 delay-200 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            Atendimento rápido 24 horas em flagrantes. Orientação jurídica imediata para proteger seus direitos.
          </p>
          <div
            className={`mt-6 md:mt-10 flex flex-col sm:flex-row gap-4 justify-center md:justify-start transition-all duration-700 delay-300 ${
              visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
          >
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-3 bg-green-cta text-navy font-montserrat font-semibold text-sm md:text-base px-6 md:px-8 py-3 md:py-4 rounded-full hover:opacity-90 transition-opacity whitespace-nowrap"
            >
              <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center text-lg" />
              Falar com o Advogado no WhatsApp
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 hidden md:flex flex-col items-center gap-1 animate-bounce">
        <span className="font-montserrat text-white/60 text-xs">Rolar</span>
        <i className="ri-arrow-down-line w-4 h-4 flex items-center justify-center text-white/60" />
      </div>
    </section>
  );
}